import { Actions } from "../vehicle/vehicleConstants";
import produce from "immer";

const initialState = {
  data: null,
  loading: false,
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.LIST_VEHICLE_TYPES:
        draft.loading = true;
        return draft;
      case Actions.LIST_VEHICLE_TYPES_SUCCEEDED:
        draft.loading = false;
        draft.data = action.payload;
        return draft;
      default:
        return state;
    }
  });
};
